import React from 'react';
import { Show, SimpleShowLayout, ShowController } from 'react-admin';
import { Typography, Box, Card, CardContent } from '@material-ui/core';
import { parse } from "query-string";
import PanelEventsList from '../../components/Panel/PanelEventsList';
import ZoneList from '../../components/Zone/ZoneList';

/**
 * PanelShow Component
 * @param {Object} props - The props passed to the component
 */
const PanelShow = (props) => {
    // Parse organization_id from the URL query string
    const { organization_id } = parse(props.location.search);

    const record = props?.record || {};

    return (
        <ShowController {...props} >
            {controllerProps =>
                <Show {...props} title="Panel" component="div">
                    <SimpleShowLayout>
                        {controllerProps && controllerProps.record && <Box marginBottom={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h4" gutterBottom>Panel Information</Typography>

                                    <Typography variant="h6" gutterBottom>UID</Typography>
                                    <Typography variant="body1" gutterBottom>{controllerProps.record.uid}</Typography>

                                    <Typography variant="h6" gutterBottom>Access Code</Typography>
                                    <Typography variant="body1" gutterBottom>{controllerProps.record.access_code}</Typography>

                                    <Typography variant="h6" gutterBottom>Installer Code</Typography>
                                    <Typography variant="body1" gutterBottom>{controllerProps.record.installer_code}</Typography>

                                    <Typography variant="h6" gutterBottom>Destination IP</Typography>
                                    <Typography variant="body1" gutterBottom>{controllerProps.record.ip}</Typography>

                                    {/* <Typography variant="h6" gutterBottom>Panel IP</Typography>
                                    <Typography variant="body1" gutterBottom>{controllerProps.record.panel_ip}</Typography> */}

                                    <Typography variant="h6" gutterBottom>Notes</Typography>
                                    <Typography variant="body1" gutterBottom>{controllerProps.record.notes}</Typography>

                                </CardContent>
                            </Card>
                        </Box>}

                        <Box marginBottom={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h4" gutterBottom>Zones</Typography>
                                    <ZoneList filter={{ panel_id: props.id }} />
                                </CardContent>
                            </Card>
                        </Box>

                        <Box marginBottom={2}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h4" gutterBottom>Panel Events</Typography>
                                    <PanelEventsList filter={{ panel_id: controllerProps ? controllerProps.record.id : record.id }} />
                                </CardContent>
                            </Card>
                        </Box>
                    </SimpleShowLayout>
                </Show>
            }
        </ShowController>
    );
};

export default PanelShow;
